import layout from '../en/layout'

const cnLayout = {}

for (const cn in layout) {
  cnLayout[cn] = cn
}

export default cnLayout
